/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Confidence_HighInputs */

const en_directory_agent_readiness_confidence_high = /** @type {(inputs: Directory_Agent_Readiness_Confidence_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High confidence`)
};

const zh_directory_agent_readiness_confidence_high = /** @type {(inputs: Directory_Agent_Readiness_Confidence_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高置信度`)
};

/**
* | output |
* | --- |
* | "High confidence" |
*
* @param {Directory_Agent_Readiness_Confidence_HighInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_confidence_high = /** @type {((inputs?: Directory_Agent_Readiness_Confidence_HighInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Confidence_HighInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_confidence_high(inputs)
	return zh_directory_agent_readiness_confidence_high(inputs)
});
export { directory_agent_readiness_confidence_high as "directory.agent_readiness.confidence.high" }